import { Box, Chip } from '@mui/material';

import ChevroneUpAndDows from 'src/icons/ChevroneUpAndDows';
import Bookmark from 'src/icons/Bookmark';
import { openBottomSheet } from 'src/components/BottomSheet';

import DateSheet from '../DateSheet';
import StreamsSheet from '../StreamsSheet';

type FeedFilterProps = {
    isFavoriteMode?: boolean;
    onFavoriteModeChange?: (enabled: boolean) => void;
};

export default function FeedFilter({ isFavoriteMode = false, onFavoriteModeChange }: FeedFilterProps) {
    const showDate = () => {
        openBottomSheet(<DateSheet />);
    };

    const showStreams = () => {
        openBottomSheet(<StreamsSheet />);
    };

    const FILTERS = [
        {
            label: 'Дата',
            onClick: showDate,
        },
        {
            label: 'Потоки',
            onClick: showStreams,
        },
    ];

    const handleFavoriteClick = () => {
        onFavoriteModeChange?.(!isFavoriteMode);
    };

    return (
        <Box
            mt={1.5}
            mb={1.5}
            display="flex"
            gap={1}
            alignItems="center"
            pb={0.5}
            sx={{
                overflowX: 'auto',

                '&::-webkit-scrollbar': {
                    height: '2px',
                },
            }}
        >
            {onFavoriteModeChange && (
                <Chip
                    label="Избранное"
                    variant="outlined"
                    component="div"
                    icon={<Bookmark fill={isFavoriteMode} />}
                    onClick={handleFavoriteClick}
                    sx={{
                        backgroundColor: 'var(--lm-surface)',
                        borderColor: isFavoriteMode ? 'var(--lm-text)' : 'var(--lm-border)',
                        fontWeight: isFavoriteMode ? 600 : 400,
                    }}
                    clickable
                />
            )}
            {FILTERS.map((filter) => (
                <Chip
                    key={filter.label}
                    label={filter.label}
                    variant="outlined"
                    component="div"
                    deleteIcon={
                        <Box>
                            <ChevroneUpAndDows />
                        </Box>
                    }
                    onClick={filter.onClick}
                    onDelete={filter.onClick}
                    sx={{
                        backgroundColor: 'var(--lm-surface)',
                    }}
                    clickable
                />
            ))}
        </Box>
    );
}
